import { Button } from '@mui/material';
import PNG404 from '../images/404.png';
import { Link } from 'react-router-dom';

export default function Page404() {
  return (
    <div className="flex flex-col items-center justify-center p-10 text-center w-full overflow-auto">
      <p className="mb-4 mt-10 text-4xl font-bold">404</p>

      <p className="my-4 text-xl">
        The page you are looking for does not exist.
      </p>

      <img src={PNG404} alt="" className="h-80 w-80" />

      <Link to="/">
        <Button className='!bg-nanonetsBlue' variant="contained">
          Go to Homepage
        </Button>
      </Link>
    </div>
  );
}
